// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__kjFBX","header":"Messages_header__11EiO"};